export const SCHEDULE_REVIEW_TOAST_KEY = "schedule-review";
export const SCHEDULE_REVIEW_DRAIN_PAGE_SIZE = 100;
export const SCHEDULE_REVIEW_DRAIN_MAX_ITERATIONS = 100;
